import type { TranslationInterface } from '.';

export const FinnishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Kirjoita viesti...',
  your_issue_has_been_resolved: 'Ongelmasi on ratkaistu!',
  new_conversation: 'Uusi keskustelu',
  welcome_screen_title: 'Tervetuloa tukichattiin',
  welcome_screen_description:
    'Olemme täällä auttamassa! Aloita keskustelu ja palaamme sinulle mahdollisimman pian.',
  your_name_placeholder: 'Nimesi',
  your_email_placeholder: 'Sähköpostiosoitteesi',
  start_chat_button: 'Keskustele tuen kanssa',
  start_chat_button_loading: 'Yhdistetään...',
  i_need_more_help: 'Tarvitsen lisää apua',
  this_was_helpful: 'Tämä oli hyödyllistä',
  optional: 'Valinnainen',
  no_conversations_yet: 'Ei vielä keskusteluja',
  back_to_conversations: 'Takaisin keskusteluihin',
  closed_conversations: 'Suljetut keskustelut',
  csat_title: 'Millainen keskustelusi oli?',
  csat_submitted_title: 'Arvioit keskustelun',
  csat_feedback_placeholder: 'Kerro lisää... (valinnainen)',
  follow_up_placeholder: 'Jatka…',
  companion_layout_label: 'Asettelu',
  companion_layout_floating: 'Kelluva',
  companion_layout_sidebar: 'Sivupalkki',
  companion_layout_fullscreen: 'Koko näyttö',
  companion_close: 'Sulje',
  companion_history: 'Keskusteluhistoria',
  companion_expand_chat: 'Laajenna keskustelu',
  companion_sidebar_dock_label: 'Telakointi',
  companion_sidebar_side_label: 'Puoli',
  companion_sidebar_left: 'Vasen',
  companion_sidebar_right: 'Oikea',
  companion_resize_chat: 'Muuta keskustelun kokoa',
  scroll_to_bottom: 'Vieritä alas',
  thinking: 'Ajattelen…',
  running: 'Suoritetaan…',
  steps: 'vaihetta',
  step_arguments: 'Argumentit',
  step_result: 'Tulos',
  attach_files:
    'Liitä kuvia, videoita, PDF-tiedostoja tai laskentataulukoita (enimmäiskoko 25 MB)',
  mark_page_active:
    'Merkitse sivulta jotain napsauttamalla sitä — peruuta Esc-näppäimellä',
  mark_page: 'Merkitse sivulta jotain kysyäksesi siitä',
  stop_response: 'Pysäytä vastaus',
  copy_reply: 'Kopioi vastaus',
  mentions_empty: 'Ei osumia',
  copied: 'Kopioitu',
  send_message: 'Lähetä viesti',
  upload_failed: 'Lataus epäonnistui: {error}',
  remove_attachment: 'Poista liite',
  json_no_items: 'Ei kohteita',
  json_no_data: 'Ei tietoja',
  json_no_chart_data: 'Kaaviolle ei ole tietoja',
  json_unsupported: 'Ei tuettu: {type}',
  json_see_less: 'Näytä vähemmän',
  json_phone_agent: 'Puhelinagentti',
  json_phone_agent_test: 'Testaa verkossa',
  page_context_remove: 'Poista sivun konteksti',
  json_see_more: 'Näytä vielä {count}',
  queued_label: '{count} Jonossa',
  remove_queued_message: 'Poista viesti jonosta',
  send_queued_now: 'Lähetä jonossa olevat viestit nyt',
  turn_failed_message: 'Jokin meni pieleen, eikä vastaus saapunut.',
  turn_failed_retry: 'Yritä uudelleen',
  page_mark_hint: 'Merkitse jotain napsauttamalla sitä',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Laatikko',
  page_mark_shape_circle: 'Ympyrä',
  page_mark_shape_arrow: 'Nuoli',
  page_mark_shape_bracket: 'Hakasulje',
  page_mark_shape_underline: 'Alleviivaus',
  page_mark_shape_highlight: 'Korostus',
  page_mark_shape_strike_through: 'Yliviivaus',
  page_mark_shape_crossed_off: 'Rastita yli',
  page_mark_shape_aria: 'Merkinnän muoto: {shape}',
  page_mark_note_placeholder: 'Lisää huomautus… (Enter liittää)',
  page_mark_attach: 'Liitä merkintä',
  page_mark_remove: 'Poista {label}',
  page_mark_region: 'Merkitty alue',
  page_mark_default_message: 'Mikä tämä on?',
  file_rejected: 'Tiedostotyyppiä ei tueta tai tiedosto on liian suuri.',
  dictate: 'Sanele',
  stop_dictation: 'Lopeta sanelu',
  dictation_mic_blocked: 'Salli mikrofonin käyttö sanellaksesi',
  dictation_unavailable: 'Sanelu ei ole juuri nyt käytettävissä',
  questions_back: 'Takaisin',
  questions_next: 'Seuraava',
  questions_send: 'Lähetä',
  questions_type_answer: 'Kirjoitan itse',
  questions_answer_placeholder: 'Kirjoita vastauksesi…',
  close_conversation_title: 'Sulje keskustelu',
  close_conversation_description: 'Haluatko varmasti sulkea tämän keskustelun?',
  close_conversation_cancel: 'Ei',
  close_conversation_confirm: 'Kyllä',
  dialog_close: 'Sulje',
  zoom_in: 'Lähennä',
  zoom_out: 'Loitonna',
  reset_zoom: 'Palauta zoomaus',
  support_chat_aria_label: 'Tukichat',
};
